// Global site configuration
export const SITE = {
  name: "TarapithTantrik.com",
  practitioner: "Shivam Chatterjee",
  phoneDisplay: "+91 83728 34728",
  whatsapp: "918372834728",
  domain: "https://tarapithtantrik.com",
};

export const LANGS = [
  { code: "en", label: "English", short: "EN" },
  { code: "bn", label: "বাংলা", short: "BN" },
  { code: "hi", label: "हिन्दी", short: "HI" },
];

export const UI = {
  en: {
    nav_home: "Home",
    nav_services: "Services",
    nav_knowledge: "Knowledge",
    nav_concerns: "Life Concerns",
    nav_visit: "Visit Tarapith",
    nav_about: "About Shivam",
    nav_contact: "Contact",
    cta_book: "Book a Puja",
    cta_speak: "Speak With Shivam Chatterjee",
    cta_request: "Request Guidance",
    cta_discuss: "Discuss Your Concern",
    cta_enquire: "Enquire About a Puja",
    cta_whatsapp: "Continue on WhatsApp",
    cta_explore: "Explore the Knowledge Hub",
    hero_eyebrow: "Sacred Authority of Tarapith Tantra",
    hero_title: "Maa Tara of Tarapith",
    hero_subtitle:
      "A deep, authoritative destination for Tarapith Tantra, Maa Tara sadhana, Dashamahavidya and Shakta tradition — with respectful spiritual guidance, puja and havan by Shivam Chatterjee.",
    services_eyebrow: "Select Your Concern",
    services_title: "How May We Guide You?",
    services_sub: "Choose a concern or a Maa Tara service to begin a guided WhatsApp enquiry.",
    pillars_eyebrow: "Deep Knowledge Ecosystem",
    pillars_title: "The Tarapith Knowledge Hub",
    pillars_sub: "Beginner to advanced understanding across the traditions of Tarapith and Tantra.",
    concerns_eyebrow: "Life Concerns & Guidance",
    concerns_title: "Guidance for Life's Real Concerns",
    read_more: "Read More",
    learn_more: "Learn More",
    last_updated: "Last updated",
    beginner: "Beginner",
    detailed: "Detailed",
    advanced: "Advanced",
    faq: "Frequently Asked Questions",
    references: "Sources & References",
    related: "Related Topics",
    // Booking drawer
    book_title: "Start Your Guided Enquiry",
    book_sub: "Share a few details and continue the conversation directly on WhatsApp.",
    field_name: "Your Name",
    field_location: "Location (City / Country)",
    field_phone: "Phone (optional)",
    field_birth: "Birth details — date, time, place (optional)",
    field_concern: "Briefly describe your concern",
    field_service: "Service / Concern",
    submit_whatsapp: "Send & Open WhatsApp",
    submitting: "Preparing...",
    book_success: "Opening WhatsApp — your details are ready to send.",
    required: "Please enter your name.",
    // Footer
    footer_tagline: "A Tarapith-first spiritual knowledge & guidance platform.",
    footer_explore: "Explore",
    footer_knowledge: "Knowledge Pillars",
    footer_legal: "Trust & Policies",
    footer_connect: "Connect",
    privacy: "Privacy Policy",
    terms: "Terms & Conditions",
    disclaimer: "Disclaimer",
    editorial: "Editorial Policy",
    rights: "All rights reserved.",
    disclaimer_short:
      "Spiritual and traditional practices are offered respectfully and do not replace qualified medical, mental-health, legal or financial advice. No specific outcome is guaranteed.",
    // Festivals
    nav_festivals: "Festival Calendar",
    festivals_eyebrow: "Sacred Lunar Calendar",
    festivals_title: "Upcoming Amavasya & Festival Dates",
    festivals_sub:
      "Amavasya, Kaushiki Amavasya and Purnima dates computed from the lunar calendar. Reserve a puja for any observance in one tap.",
    festival_book: "Enquire for this date",
    view_all_dates: "View full calendar",
    days_away: "days away",
    today: "Today",
    tomorrow: "Tomorrow",
    next_observance: "Next observance",
    note: "Note",
    festivals_disclaimer:
      "Dates are computed from the lunar cycle in Indian Standard Time and may differ by a day from your local panchang. Please confirm the exact muhurta with Shivam Chatterjee before travelling.",
    // Voices
    voices_eyebrow: "Devotee Voices",
    voices_title: "In Their Words",
    // Translate
    translate_title: "Choose your language",
    translate_sub: "Read TarapithTantrik in the language you are most comfortable with.",
    translate_search: "Search a language",
    translate_note:
      "Bengali and Hindi are reviewed by our team. Other languages are machine-assisted and continuously improved.",
    no_results: "No language matches your search.",
    ai_translated: "Machine-assisted translation",
    // Reminders
    remind_me: "Remind me",
    // Daily Darshan
    darshan_title: "Daily Darshan",
    start_enquiry: "Start enquiry",
    nav_astrology: "Astrology",
    subscribe_cta: "Get it every morning",
    subscribe_title: "Daily darshan on WhatsApp",
    subscribe_sub: "Leave your name and WhatsApp number and the day's reflection will be sent to you personally each morning.",
    subscribe_confirm: "Send it to me daily",
    subscribe_success: "You are on the daily darshan list.",
    subscribe_failed: "Could not add you. Please try again.",
    subscribe_privacy: "Your number is used only for the daily darshan and to reply to your enquiries. Reply STOP any time to be removed.",
    share_eyebrow: "Your experience",
    share_title: "Share your experience",
    share_sub: "If the guidance you received was meaningful, your words help other devotees decide with confidence. Every submission is read before it appears.",
    share_placeholder: "What guidance did you receive, and how did it help you?",
    share_cta: "Send my experience",
    share_success: "Thank you — your words have reached us.",
    share_pending_note: "Shivam reads each experience personally before it appears on the site.",
    share_failed: "Could not send. Please try again.",
    share_invalid: "Please add your name and a few words about your experience.",
    share_privacy: "Your name and city may be shown with your words once approved. Nothing is published without review.",
    core_pillar: "Core Pillar",
    darshan_share: "Share on WhatsApp",
    darshan_copy: "Copy blessing",
    darshan_copied: "Blessing copied.",
    darshan_copy_failed: "Could not copy. Please select and copy manually.",
    darshan_note: "A new reflection each day.",
    reminder_sub: "We will send you a WhatsApp reminder a few days before this observance, so there is time to arrange the puja.",
    reminder_phone: "WhatsApp number (with country code)",
    reminder_cta: "Set my reminder",
    reminder_success: "Your reminder is set.",
    reminder_failed: "Could not set the reminder. Please try again.",
    reminder_invalid: "Please enter your name and a valid WhatsApp number.",
    reminder_privacy: "Your number is used only to send this reminder and to reply to your enquiry. It is never shared or sold.",
    // Countdown
    countdown_eyebrow: "The Next Sacred Night",
    countdown_cta: "Reserve your sankalp",
    countdown_note: "Sankalp requests for this night are taken in advance so the puja can be arranged with full procedure. Share your name and gotra early.",
    cd_days: "Days",
    cd_hours: "Hours",
    cd_minutes: "Minutes",
    cd_seconds: "Seconds",

  },
  bn: {
    nav_home: "হোম",
    nav_services: "সেবা",
    nav_knowledge: "জ্ঞানকোষ",
    nav_concerns: "জীবন সমস্যা",
    nav_visit: "তারাপীঠ ভ্রমণ",
    nav_about: "শিবম সম্পর্কে",
    nav_contact: "যোগাযোগ",
    cta_book: "পূজা বুক করুন",
    cta_speak: "শিবম চ্যাটার্জির সাথে কথা বলুন",
    cta_request: "পরামর্শ চান",
    cta_discuss: "আপনার সমস্যা আলোচনা করুন",
    cta_enquire: "পূজা সম্পর্কে জানতে চান",
    cta_whatsapp: "হোয়াটসঅ্যাপে এগিয়ে যান",
    cta_explore: "জ্ঞানকোষ অন্বেষণ করুন",
    hero_eyebrow: "তারাপীঠ তন্ত্রের পবিত্র কেন্দ্র",
    hero_title: "তারাপীঠের মা তারা",
    hero_subtitle:
      "তারাপীঠ তন্ত্র, মা তারা সাধনা, দশমহাবিদ্যা ও শাক্ত ঐতিহ্যের গভীর ও প্রামাণিক ঠিকানা — শিবম চ্যাটার্জির শ্রদ্ধাশীল আধ্যাত্মিক পরামর্শ, পূজা ও যজ্ঞসহ।",
    services_eyebrow: "আপনার সমস্যা বেছে নিন",
    services_title: "আমরা কীভাবে সাহায্য করতে পারি?",
    services_sub: "একটি সমস্যা বা মা তারা সেবা বেছে নিয়ে হোয়াটসঅ্যাপে পরামর্শ শুরু করুন।",
    pillars_eyebrow: "গভীর জ্ঞানকোষ",
    pillars_title: "তারাপীঠ জ্ঞান কেন্দ্র",
    pillars_sub: "তারাপীঠ ও তন্ত্রের ঐতিহ্য — প্রাথমিক থেকে উন্নত স্তর পর্যন্ত।",
    concerns_eyebrow: "জীবন সমস্যা ও পরামর্শ",
    concerns_title: "জীবনের প্রকৃত সমস্যার জন্য পরামর্শ",
    read_more: "আরও পড়ুন",
    learn_more: "বিস্তারিত জানুন",
    last_updated: "সর্বশেষ হালনাগাদ",
    beginner: "প্রাথমিক",
    detailed: "বিস্তারিত",
    advanced: "উন্নত",
    faq: "সাধারণ জিজ্ঞাসা",
    references: "সূত্র ও তথ্যসূত্র",
    related: "সম্পর্কিত বিষয়",
    book_title: "আপনার পরামর্শ শুরু করুন",
    book_sub: "কয়েকটি তথ্য দিন এবং সরাসরি হোয়াটসঅ্যাপে কথা চালিয়ে যান।",
    field_name: "আপনার নাম",
    field_location: "অবস্থান (শহর / দেশ)",
    field_phone: "ফোন (ঐচ্ছিক)",
    field_birth: "জন্ম বিবরণ — তারিখ, সময়, স্থান (ঐচ্ছিক)",
    field_concern: "সংক্ষেপে আপনার সমস্যা লিখুন",
    field_service: "সেবা / সমস্যা",
    submit_whatsapp: "পাঠান ও হোয়াটসঅ্যাপ খুলুন",
    submitting: "প্রস্তুত হচ্ছে...",
    book_success: "হোয়াটসঅ্যাপ খোলা হচ্ছে — আপনার তথ্য প্রস্তুত।",
    required: "অনুগ্রহ করে আপনার নাম লিখুন।",
    footer_tagline: "তারাপীঠ-কেন্দ্রিক আধ্যাত্মিক জ্ঞান ও পরামর্শ মঞ্চ।",
    footer_explore: "অন্বেষণ",
    footer_knowledge: "জ্ঞান স্তম্ভ",
    footer_legal: "বিশ্বাস ও নীতি",
    footer_connect: "যোগাযোগ",
    privacy: "গোপনীয়তা নীতি",
    terms: "শর্তাবলী",
    disclaimer: "দাবিত্যাগ",
    editorial: "সম্পাদকীয় নীতি",
    rights: "সর্বস্বত্ব সংরক্ষিত।",
    disclaimer_short:
      "আধ্যাত্মিক ও ঐতিহ্যবাহী অনুশীলন শ্রদ্ধার সাথে প্রদান করা হয় এবং তা যোগ্য চিকিৎসা, মানসিক, আইনি বা আর্থিক পরামর্শের বিকল্প নয়। কোনো নির্দিষ্ট ফলাফলের নিশ্চয়তা দেওয়া হয় না।",
    nav_festivals: "উৎসব পঞ্জিকা",
    festivals_eyebrow: "পবিত্র চান্দ্র পঞ্জিকা",
    festivals_title: "আগামী অমাবস্যা ও উৎসবের তারিখ",
    festivals_sub:
      "চান্দ্র পঞ্জিকা অনুসারে গণনা করা অমাবস্যা, কৌশিকী অমাবস্যা ও পূর্ণিমার তারিখ। যেকোনো তিথির পূজার জন্য এক ক্লিকে অনুরোধ করুন।",
    festival_book: "এই তারিখের জন্য অনুরোধ",
    view_all_dates: "সম্পূর্ণ পঞ্জিকা দেখুন",
    days_away: "দিন বাকি",
    today: "আজ",
    tomorrow: "আগামীকাল",
    next_observance: "পরবর্তী তিথি",
    note: "দ্রষ্টব্য",
    festivals_disclaimer:
      "তারিখগুলি ভারতীয় সময় অনুসারে চান্দ্রচক্র থেকে গণনা করা; আপনার স্থানীয় পঞ্জিকার থেকে এক দিন পার্থক্য হতে পারে। যাত্রার আগে শিবম চ্যাটার্জীর সাথে সঠিক মুহূর্ত নিশ্চিত করুন।",
    voices_eyebrow: "ভক্তদের কথা",
    voices_title: "তাঁদের নিজের ভাষায়",
    translate_title: "আপনার ভাষা নির্বাচন করুন",
    translate_sub: "যে ভাষায় আপনি সবচেয়ে স্বচ্ছন্দ, সেই ভাষায় TarapithTantrik পড়ুন।",
    translate_search: "ভাষা খুঁজুন",
    translate_note:
      "বাংলা ও হিন্দি আমাদের দল দ্বারা পরিমার্জিত। অন্য ভাষাগুলি যন্ত্র-সহায়ক অনুবাদ এবং ক্রমাগত উন্নত করা হচ্ছে।",
    remind_me: "আমাকে মনে করান",
    darshan_title: "দৈনিক দর্শন",
    start_enquiry: "অনুরোধ শুরু করুন",
    nav_astrology: "জ্যোতিষ",
    subscribe_cta: "প্রতিদিন সকালে পান",
    subscribe_title: "হোয়াটসঅ্যাপে দৈনিক দর্শন",
    subscribe_sub: "আপনার নাম ও হোয়াটসঅ্যাপ নম্বর দিন — প্রতিদিন সকালে সেই দিনের ভাবনা আপনাকে পাঠানো হবে।",
    subscribe_confirm: "প্রতিদিন পাঠান",
    subscribe_success: "আপনি দৈনিক দর্শন তালিকায় আছেন।",
    subscribe_failed: "যোগ করা যায়নি। আবার চেষ্টা করুন।",
    subscribe_privacy: "আপনার নম্বর কেবল দৈনিক দর্শন ও আপনার অনুরোধের উত্তরের জন্য ব্যবহৃত হয়। যেকোনো সময় STOP লিখে সরে যেতে পারেন।",
    share_eyebrow: "আপনার অভিজ্ঞতা",
    share_title: "আপনার অভিজ্ঞতা জানান",
    share_sub: "প্রাপ্ত পরামর্শ যদি অর্থবহ হয়ে থাকে, আপনার কথা অন্য ভক্তদের সিদ্ধান্ত নিতে সাহায্য করবে। প্রতিটি লেখা প্রকাশের আগে পড়া হয়।",
    share_placeholder: "আপনি কী পরামর্শ পেয়েছিলেন এবং তা কীভাবে সহায়ক হয়েছিল?",
    share_cta: "আমার অভিজ্ঞতা পাঠান",
    share_success: "ধন্যবাদ — আপনার কথা আমাদের কাছে পৌঁছেছে।",
    share_pending_note: "প্রকাশের আগে শিবম প্রতিটি অভিজ্ঞতা নিজে পড়েন।",
    share_failed: "পাঠানো যায়নি। আবার চেষ্টা করুন।",
    share_invalid: "অনুগ্রহ করে আপনার নাম ও অভিজ্ঞতা সম্পর্কে কিছু কথা লিখুন।",
    share_privacy: "অনুমোদনের পর আপনার নাম ও শহর আপনার কথার সঙ্গে দেখানো হতে পারে। পর্যালোচনা ছাড়া কিছুই প্রকাশিত হয় না।",
    core_pillar: "মূল স্তম্ভ",
    darshan_share: "হোয়াটসঅ্যাপে শেয়ার করুন",
    darshan_copy: "আশীর্বাণী কপি করুন",
    darshan_copied: "আশীর্বাণী কপি হয়েছে।",
    darshan_copy_failed: "কপি করা যায়নি। অনুগ্রহ করে নিজে নির্বাচন করে কপি করুন।",
    darshan_note: "প্রতিদিন নতুন ভাবনা।",
    reminder_sub: "এই তিথির কয়েক দিন আগে আমরা আপনাকে হোয়াটসঅ্যাপে মনে করিয়ে দেব, যাতে পূজার ব্যবস্থা করার সময় থাকে।",
    reminder_phone: "হোয়াটসঅ্যাপ নম্বর (দেশের কোড সহ)",
    reminder_cta: "মনে করানোর ব্যবস্থা করুন",
    reminder_success: "আপনার রিমাইন্ডার সেট হয়েছে।",
    reminder_failed: "রিমাইন্ডার সেট করা যায়নি। আবার চেষ্টা করুন।",
    reminder_invalid: "আপনার নাম ও সঠিক হোয়াটসঅ্যাপ নম্বর দিন।",
    reminder_privacy: "আপনার নম্বর কেবল এই রিমাইন্ডার ও আপনার অনুরোধের উত্তরের জন্য ব্যবহৃত হয়। কখনও শেয়ার বা বিক্রি করা হয় না।",
    countdown_eyebrow: "পরবর্তী পবিত্র রাত্রি",
    countdown_cta: "আপনার সংকল্প সংরক্ষণ করুন",
    countdown_note: "এই রাত্রির সংকল্প অনুরোধ আগেই নেওয়া হয় যাতে যথাবিধি পূজার ব্যবস্থা করা যায়। আপনার নাম ও গোত্র আগে জানান।",
    cd_days: "দিন",
    cd_hours: "ঘণ্টা",
    cd_minutes: "মিনিট",
    cd_seconds: "সেকেন্ড",
    no_results: "আপনার অনুসন্ধানে কোনো ভাষা মেলেনি।",
    ai_translated: "যন্ত্র-সহায়ক অনুবাদ",

  },
  hi: {
    nav_home: "होम",
    nav_services: "सेवाएँ",
    nav_knowledge: "ज्ञानकोष",
    nav_concerns: "जीवन समस्याएँ",
    nav_visit: "तारापीठ यात्रा",
    nav_about: "शिवम के बारे में",
    nav_contact: "संपर्क",
    cta_book: "पूजा बुक करें",
    cta_speak: "शिवम चटर्जी से बात करें",
    cta_request: "मार्गदर्शन प्राप्त करें",
    cta_discuss: "अपनी समस्या पर चर्चा करें",
    cta_enquire: "पूजा के बारे में पूछें",
    cta_whatsapp: "व्हाट्सएप पर जारी रखें",
    cta_explore: "ज्ञानकोष देखें",
    hero_eyebrow: "तारापीठ तंत्र का पवित्र केंद्र",
    hero_title: "तारापीठ की माँ तारा",
    hero_subtitle:
      "तारापीठ तंत्र, माँ तारा साधना, दशमहाविद्या और शाक्त परंपरा का गहन एवं प्रामाणिक स्थान — शिवम चटर्जी द्वारा श्रद्धापूर्ण आध्यात्मिक मार्गदर्शन, पूजा और हवन के साथ।",
    services_eyebrow: "अपनी समस्या चुनें",
    services_title: "हम आपकी कैसे सहायता करें?",
    services_sub: "एक समस्या या माँ तारा सेवा चुनकर व्हाट्सएप पर मार्गदर्शन शुरू करें।",
    pillars_eyebrow: "गहन ज्ञानकोष",
    pillars_title: "तारापीठ ज्ञान केंद्र",
    pillars_sub: "तारापीठ और तंत्र की परंपराएँ — प्रारंभिक से उन्नत स्तर तक।",
    concerns_eyebrow: "जीवन समस्याएँ व मार्गदर्शन",
    concerns_title: "जीवन की वास्तविक समस्याओं के लिए मार्गदर्शन",
    read_more: "और पढ़ें",
    learn_more: "अधिक जानें",
    last_updated: "अंतिम अद्यतन",
    beginner: "प्रारंभिक",
    detailed: "विस्तृत",
    advanced: "उन्नत",
    faq: "अक्सर पूछे जाने वाले प्रश्न",
    references: "स्रोत व संदर्भ",
    related: "संबंधित विषय",
    book_title: "अपना मार्गदर्शन शुरू करें",
    book_sub: "कुछ विवरण साझा करें और सीधे व्हाट्सएप पर बातचीत जारी रखें।",
    field_name: "आपका नाम",
    field_location: "स्थान (शहर / देश)",
    field_phone: "फ़ोन (वैकल्पिक)",
    field_birth: "जन्म विवरण — तिथि, समय, स्थान (वैकल्पिक)",
    field_concern: "संक्षेप में अपनी समस्या बताएँ",
    field_service: "सेवा / समस्या",
    submit_whatsapp: "भेजें व व्हाट्सएप खोलें",
    submitting: "तैयार हो रहा है...",
    book_success: "व्हाट्सएप खुल रहा है — आपके विवरण तैयार हैं।",
    required: "कृपया अपना नाम दर्ज करें।",
    footer_tagline: "तारापीठ-केंद्रित आध्यात्मिक ज्ञान व मार्गदर्शन मंच।",
    footer_explore: "अन्वेषण",
    footer_knowledge: "ज्ञान स्तंभ",
    footer_legal: "विश्वास व नीतियाँ",
    footer_connect: "संपर्क",
    privacy: "गोपनीयता नीति",
    terms: "नियम व शर्तें",
    disclaimer: "अस्वीकरण",
    editorial: "संपादकीय नीति",
    rights: "सर्वाधिकार सुरक्षित।",
    disclaimer_short:
      "आध्यात्मिक व पारंपरिक अभ्यास श्रद्धापूर्वक प्रदान किए जाते हैं और ये योग्य चिकित्सा, मानसिक, कानूनी या वित्तीय सलाह का विकल्प नहीं हैं। किसी निश्चित परिणाम की गारंटी नहीं दी जाती।",
    nav_festivals: "उत्सव पंचांग",
    festivals_eyebrow: "पवित्र चंद्र पंचांग",
    festivals_title: "आगामी अमावस्या व उत्सव तिथियाँ",
    festivals_sub:
      "चंद्र गणना से निकाली गई अमावस्या, कौशिकी अमावस्या व पूर्णिमा तिथियाँ। किसी भी तिथि की पूजा हेतु एक क्लिक में अनुरोध करें।",
    festival_book: "इस तिथि हेतु अनुरोध",
    view_all_dates: "पूरा पंचांग देखें",
    days_away: "दिन शेष",
    today: "आज",
    tomorrow: "कल",
    next_observance: "अगली तिथि",
    note: "ध्यान दें",
    festivals_disclaimer:
      "तिथियाँ भारतीय समय के अनुसार चंद्रचक्र से गणना की गई हैं और आपके स्थानीय पंचांग से एक दिन भिन्न हो सकती हैं। यात्रा से पूर्व शिवम चटर्जी से सही मुहूर्त की पुष्टि करें।",
    voices_eyebrow: "भक्तों के अनुभव",
    voices_title: "उनके ही शब्दों में",
    translate_title: "अपनी भाषा चुनें",
    translate_sub: "जिस भाषा में आप सहज हैं, उसी में TarapithTantrik पढ़ें।",
    translate_search: "भाषा खोजें",
    translate_note:
      "बंगाली व हिंदी हमारी टीम द्वारा समीक्षित हैं। अन्य भाषाएँ मशीन-सहायक अनुवाद हैं और लगातार सुधारी जा रही हैं।",
    remind_me: "मुझे याद दिलाएँ",
    darshan_title: "दैनिक दर्शन",
    start_enquiry: "अनुरोध शुरू करें",
    nav_astrology: "ज्योतिष",
    subscribe_cta: "हर सुबह प्राप्त करें",
    subscribe_title: "व्हाट्सएप पर दैनिक दर्शन",
    subscribe_sub: "अपना नाम व व्हाट्सएप नंबर दें — हर सुबह उस दिन का चिंतन आपको भेजा जाएगा।",
    subscribe_confirm: "मुझे रोज़ भेजें",
    subscribe_success: "आप दैनिक दर्शन सूची में हैं।",
    subscribe_failed: "जोड़ा नहीं जा सका। कृपया पुनः प्रयास करें।",
    subscribe_privacy: "आपका नंबर केवल दैनिक दर्शन व आपके अनुरोधों के उत्तर हेतु उपयोग होता है। कभी भी STOP लिखकर हट सकते हैं।",
    share_eyebrow: "आपका अनुभव",
    share_title: "अपना अनुभव साझा करें",
    share_sub: "यदि प्राप्त मार्गदर्शन सार्थक रहा, तो आपके शब्द अन्य भक्तों को निर्णय लेने में सहायता करेंगे। प्रत्येक अनुभव प्रकाशन से पूर्व पढ़ा जाता है।",
    share_placeholder: "आपको कौन-सा मार्गदर्शन मिला और वह कैसे सहायक रहा?",
    share_cta: "मेरा अनुभव भेजें",
    share_success: "धन्यवाद — आपके शब्द हमें प्राप्त हुए।",
    share_pending_note: "प्रकाशन से पूर्व शिवम प्रत्येक अनुभव स्वयं पढ़ते हैं।",
    share_failed: "भेजा नहीं जा सका। कृपया पुनः प्रयास करें।",
    share_invalid: "कृपया अपना नाम व अनुभव के बारे में कुछ शब्द लिखें।",
    share_privacy: "अनुमोदन के बाद आपका नाम व शहर आपके शब्दों के साथ दिखाया जा सकता है। समीक्षा के बिना कुछ प्रकाशित नहीं होता।",
    core_pillar: "मूल स्तंभ",
    darshan_share: "व्हाट्सएप पर साझा करें",
    darshan_copy: "आशीर्वचन कॉपी करें",
    darshan_copied: "आशीर्वचन कॉपी हो गया।",
    darshan_copy_failed: "कॉपी नहीं हो सका। कृपया स्वयं चुनकर कॉपी करें।",
    darshan_note: "हर दिन एक नया चिंतन।",
    reminder_sub: "इस तिथि से कुछ दिन पहले हम आपको व्हाट्सएप पर याद दिला देंगे, जिससे पूजा की व्यवस्था का समय रहे।",
    reminder_phone: "व्हाट्सएप नंबर (देश कोड सहित)",
    reminder_cta: "मेरा रिमाइंडर सेट करें",
    reminder_success: "आपका रिमाइंडर सेट हो गया।",
    reminder_failed: "रिमाइंडर सेट नहीं हो सका। कृपया पुनः प्रयास करें।",
    reminder_invalid: "कृपया अपना नाम व सही व्हाट्सएप नंबर दर्ज करें।",
    reminder_privacy: "आपका नंबर केवल इस रिमाइंडर व आपके अनुरोध के उत्तर हेतु उपयोग होता है। इसे कभी साझा या बेचा नहीं जाता।",
    countdown_eyebrow: "अगली पवित्र रात्रि",
    countdown_cta: "अपना संकल्प आरक्षित करें",
    countdown_note: "इस रात्रि के संकल्प अनुरोध पहले से लिए जाते हैं ताकि विधिपूर्वक पूजा की व्यवस्था हो सके। अपना नाम व गोत्र पहले बताएं।",
    cd_days: "दिन",
    cd_hours: "घंटे",
    cd_minutes: "मिनट",
    cd_seconds: "सेकंड",
    no_results: "आपकी खोज से कोई भाषा मेल नहीं खाती।",
    ai_translated: "मशीन-सहायक अनुवाद",

  },
};
